import {
  ControlPosition,
  MapControl,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useEffect, useState } from "react";
import { FormCheck, FormControl } from "react-bootstrap";

const CommonMapTrafficLayer = ({ children }) => {
  const map = useMap();
  const lib = useMapsLibrary("maps");
  const [showTraffic, setShowTraffic] = useState(false);

  useEffect(() => {
    if (!map) return;
  }, [map]);

  useEffect(() => {
    if (showTraffic) {
      var trafficLayer = new lib.TrafficLayer();

      trafficLayer.setMap(map);
    }

    return () => {
      if (trafficLayer) {
        trafficLayer.setMap(null);
        trafficLayer = null;
      }
    };
  }, [showTraffic]);

  return (
    <React.Fragment>
      <MapControl position={ControlPosition.LEFT_BOTTOM}>
        <div style={{ background: "#ffffffff", margin: "10px" }}>
          <div
            style={{
              background: "white",
              padding: "8px",
              borderRadius: "14px",
              // boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              // marginLeft: "10px",
            }}
            //className="gm-style"
          >
            <input
              type="checkbox"
              checked={showTraffic}
              onChange={(e) => {
                setShowTraffic(e.target.checked);
              }}
            ></input>
            <span className="gm-style ms-1">Traffic</span>

            {/* <FormCheck
            label={"Show Traffic"}
            type={"switch"}
            checked={showTraffic}
            onChange={(e) => {
              setShowTraffic(e.target.checked);
            }}
            className="m-0 align-items-bottom"
          /> */}
          </div>
        </div>
      </MapControl>
    </React.Fragment>
  );
};

export default CommonMapTrafficLayer;
